import { Box, Button, Image, Text } from "atoms";
import React from "react";
import SuccessIcon from "assets/img/success.png";
import { useNavigate } from "react-router-dom";

export const ResetSuccess = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <Image src={SuccessIcon} objectFit="contain" width="8rem" />
      <Text
        fontSize="2rem"
        color="primary.900"
        fontFamily="NeometricBold"
        mb="2rem"
        mt="4rem"
      >
        Success
      </Text>
      <Text fontSize="1.6rem" color="neutral.800" mb="4rem">
        Your password has been successfuly changed
      </Text>
      <Button
        my="2rem"
        width="100%"
        variant="primary"
        height="4.8rem"
        type="submit"
        onClick={() => navigate("/login")}
      >
        Back to Login
      </Button>
    </Box>
  );
};
